// extracted by mini-css-extract-plugin
module.exports = {"container":"SwitchList-modulecontainer1A3","switch":"SwitchList-moduleswitch1gQ","active":"SwitchList-moduleactive2pT"};